import React, { useState } from 'react';
import './ModalStyles.css';
import apiService from '../../services/api';

const AddCategoryModal = ({ isOpen, onClose, onSave, categories = [] }) => {
  const [categoryData, setCategoryData] = useState({
    name: '',
    shortCode: '',
    description: '',
    addAsSubCat: false,
    parentId: ''
  });
  const [isSaving, setIsSaving] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCategoryData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryData.name.trim()) {
      alert('Please fill in the category name');
      return;
    }
    if (categoryData.addAsSubCat && !categoryData.parentId) {
      alert('Please select a parent category');
      return;
    }

    setIsSaving(true);
    setApiError(null);

    try {
      const payload = {
        name: categoryData.name.trim(),
        short_code: categoryData.shortCode.trim(),
        description: categoryData.description.trim(),
        category_type: 'product',
        add_as_sub_cat: categoryData.addAsSubCat ? 1 : 0,
        parent_id: categoryData.addAsSubCat && categoryData.parentId ? categoryData.parentId : undefined
      };

      const res = await apiService.createCategory(payload);
      const createdCategory = res.data || res;

      if (onSave) {
        onSave(createdCategory);
      }

      setCategoryData({ name: '', shortCode: '', description: '', addAsSubCat: false, parentId: '' });
      setApiError(null);
      onClose();
    } catch (err) {
      setApiError('Failed to create category: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setCategoryData({ name: '', shortCode: '', description: '', addAsSubCat: false, parentId: '' });
    setApiError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Category</h2>
          <button className="modal-close" onClick={handleClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {apiError && (
            <div style={{
              marginBottom: '1rem',
              padding: '0.6rem 0.9rem',
              background: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '6px',
              color: '#991b1b',
              fontSize: '0.85rem'
            }}>
              {apiError}
            </div>
          )}

          <div className="form-group">
            <label>Category name:*</label>
            <input
              type="text"
              name="name"
              value={categoryData.name}
              onChange={handleChange}
              placeholder="Category name"
              required
            />
          </div>

          <div className="form-group">
            <label>Category Code:</label>
            <input
              type="text"
              name="shortCode"
              value={categoryData.shortCode}
              onChange={handleChange}
              placeholder="Category Code"
            />
          </div>

          <div className="form-group">
            <label>Description:</label>
            <textarea
              name="description"
              value={categoryData.description}
              onChange={handleChange}
              placeholder="Description"
              style={{ width: '100%', padding: '0.75rem', border: '1px solid #e5e7eb', borderRadius: '4px', resize: 'vertical', minHeight: '80px', fontFamily: 'inherit' }}
            />
          </div>

          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="checkbox"
                name="addAsSubCat"
                checked={categoryData.addAsSubCat}
                onChange={handleChange}
                style={{ marginRight: '8px', width: 'auto', height: 'auto' }}
              />
              Add as sub-taxonomy
            </label>
          </div>

          {categoryData.addAsSubCat && (
             <div className="form-group">
               <label>Select parent category:*</label>
               <select
                 name="parentId"
                 value={categoryData.parentId}
                 onChange={handleChange}
                 required={categoryData.addAsSubCat}
               >
                 <option value="">Please Select</option>
                 {categories.map(cat => (
                   <option key={cat.id} value={cat.id}>{cat.name}</option>
                 ))}
               </select>
             </div>
          )}

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={handleClose} disabled={isSaving}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn-save"
              disabled={isSaving}
              style={{ opacity: isSaving ? 0.7 : 1, cursor: isSaving ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategoryModal;
